import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  popup: {
    top: 0,
    left: 0,
    outline: 'none',
    borderRadius: 2,
    padding: 20,
    minWidth: 300,
    overflow: 'hidden auto',
    boxSizing: 'border-box',
    background: 'white',
    width: '60vw',
    position: 'relative',
    '&.sm': {
      width: '40vw',
      maxWidth: 590,
      [theme.breakpoints.down('sm')]: {
        width: '90%',
      },
    },
  },
  close: {
    position: 'absolute',
    top: 10,
    right: 10,
    cursor: 'pointer',
    height: 20,
    width: 20,
    display: 'grid',
    placeItems: 'center',
    //color: theme.palette.textColor.main,
  },
  close2: {
    position: 'absolute',
    top: 10,
    right: 10,
    cursor: 'pointer',
    height: 20,
    width: 20,
    display: 'grid',
    placeItems: 'center',
    //color: theme.palette.white.main,
  },
  modal: {
    border: 'none',
    display: 'grid',
    placeItems: 'center',
   // backgroundColor: ({ noBackground }) => (noBackground ? 'rgba(0,0,0,0.7)' : undefined),
  },
  confirmHeaderText: {
    fontWeight: 400,
    fontSize: 22,
    marginTop: 5,
    marginBottom: 15,
    //color: theme.palette.textColor.main,
    //'& i': { color: theme.palette.secondary.main },
    '& i ~ span': { paddingLeft: 10 },
  },
  confirmBody: {
    fontSize: 14,
    fontWeight: 200,
    paddingBottom: 10,
    //color: theme.palette.textColor.main,
    paddingTop: 10,
    paddingLeft: 10,
  },
  cancelText: {
    //color: theme.palette.textColor.main,
  },
}));

export default useStyles;
